export default __webpack_public_path__ + "static/media/Eleanor 9781408336731.bee0caf0.jpg";